import { GetterTree } from 'vuex'
import { RootState } from '../../types'
import { AuthState } from './types'

export const getters: GetterTree<AuthState, RootState> = {
  test: () => {
    return 'auth module test getters'
  },
  isLogin: (state: any) => {
    return state.signInMethod !== ''
  },
  getCustomerName: (state: any) => {
    return state.customerName
  },
  getAdminCustomerList: (state: any) => {
    if (!state.licenseList.length) return []
    const uniqueId = [...new Set([].concat(state.licenseList).map((obj: any) => obj.customerId))]
    return uniqueId.map((id) => {
      const target = state.licenseList.find((obj: any) => id === obj.customerId)
      return target.customerName
    })
  }
}

export default getters
